import { Component, OnInit } from '@angular/core';
import { Company } from 'src/app/models/company.model';
import { SignatureRequestService } from 'src/app/services/signature-request.service';

@Component({
  selector: 'app-signature-link-invalidated',
  templateUrl: './signature-link-invalidated.component.html',
  styleUrls: ['./signature-link-invalidated.component.sass']
})
export class SignatureLinkInvalidatedComponent implements OnInit {

  public company:Company = null as any;

  constructor(private signature_request:SignatureRequestService) { }

  ngOnInit(): void {
    this.signature_request.company.subscribe(
      data => {
        this.company = data;
      }
    );
  }
}
